import { render } from "./OrganizationProfile.vue?vue&type=template&id=b8454e9c"
import script from "./OrganizationProfile.vue?vue&type=script&lang=js"
export * from "./OrganizationProfile.vue?vue&type=script&lang=js"

import "./OrganizationProfile.vue?vue&type=style&index=0&id=b8454e9c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__